import { BE_ADMIN_BASE } from "./environment";
import { apiGet, apiPost } from "./apiClient";

export const getMonitoringSummary = (opts) =>
  apiGet(`${BE_ADMIN_BASE}/monitoring/summary`, opts);

export const getMonitoringHistory = (payload, opts) =>
  apiPost(`${BE_ADMIN_BASE}/monitoring/history`, payload, opts);

export const fetchMonitoringConfigsAPI = (payload, opts) =>
  apiPost(`${BE_ADMIN_BASE}/monitoring/config/fetchdetails`, payload, opts);

export const saveMonitoringConfigAPI = (payload, opts) =>
  apiPost(`${BE_ADMIN_BASE}/monitoring/config`, payload, opts);

export const updateMonitoringConfigAPI = (payload, opts) =>
  apiPost(`${BE_ADMIN_BASE}/monitoring/config/update`, payload, opts);
